<template>
  <svg
    class="own-progress-spinner"
    :class="color"
    :width="size"
    :height="size"
    :viewBox="`0 0 ${viewBox} ${viewBox}`"
    fill="none"
  >
    <circle
      class="own-progress-spinner__track"
      :cx="viewBox / 2"
      :cy="viewBox / 2"
      :r="radius"
      :stroke-width="strokeWidth"
      stroke="currentColor"
    />
    <circle
      class="own-progress-spinner__arc"
      :cx="viewBox / 2"
      :cy="viewBox / 2"
      :r="radius"
      :stroke-width="strokeWidth"
      stroke="currentColor"
      stroke-linecap="round"
      :stroke-dasharray="circumference"
    />
  </svg>
</template>

<script>
export default {
  name: 'OwnProgressSpinner',
  props: {
    color: { type: String, default: 'text-color-primary' },
    size: { type: [Number, String], default: 40 },
  },
  computed: {
    circumference() {
      return 2 * Math.PI * this.radius
    },
    radius() {
      return (this.viewBox - this.strokeWidth) / 2
    },
    strokeWidth() {
      return 2.5
    },
    viewBox() {
      return 24
    },
  },
}
</script>

<style lang="scss">
.own-progress-spinner {
  display: inline-block;
  color: var(--text-color-secondary);
  animation: spinner-rotate 0.9s linear infinite;

  &__track {
    opacity: 0.1;
  }

  &__arc {
    animation: spinner-dash 1.4s ease-in-out infinite;
    transform-origin: center;
  }
}

@keyframes spinner-rotate {
  to {
    transform: rotate(360deg);
  }
}

@keyframes spinner-dash {
  0% {
    stroke-dashoffset: 67.5;
    transform: rotate(0deg);
  }
  50% {
    stroke-dashoffset: 16.9;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 67.5;
    transform: rotate(360deg);
  }
}
</style>
